export default "__VITE_ASSET__VwVIPN6e__"